/* esm.sh - @unhead/react@3.4.1/dist/shared/react.BvsYt2da */
import{createContext as t}from"react";var o=t(null);export{o as U};
//# sourceMappingURL=react.BvsYt2da.mjs.map